<template>

  <div class="height-100">
    <Unavailable
      v-if="unavailable"
      title="Templates de requisição"
      class="height-100" />
      <div
        v-if="!unavailable"
        class="vflex">
        <div class="vflex-row-0 vflex-header p-3">
          <div class="page-title">
            <div class="title">
              <h4>{{ $t('Requisition templates') }}</h4>
            </div>
            <div class="btn-row">
              <div class="form-inline">
                <input-keyword
                  @input="setKeywords"
                  :placeholder="$t('Search')"
                  class="mr-2" />
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="showCreateModal()">
                  + {{ $t('New template') }}
                  </button>
              </div>
            </div>
          </div>
        </div>
        <div class="vflex-row-1">
          <Paginaty
            :total="paginate.total"
            :pages="paginate.pages"
            :page="paginate.page"
            :creating="creating"
            :loading="loading"
            @changePage="loadData">
            <template slot="content">
              <table class="table">
                <thead>
                  <tr>
                    <th-sort
                      field="name"
                      :value="sort"
                      @input="setSort">{{ $t('Title') }}</th-sort>
                    <th-sort
                      field="created_at"
                      :value="sort"
                      @input="setSort">{{ $t('Created at') }}</th-sort>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in requisitions"
                    :key="index">
                    <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal (item)">{{ item.title }}</a></td>
                    <td class="text-truncate">{{ $d(new Date(item.created_at), 'short') }}</td>
                    <td><a href="javascript:void(0)" @click="deleteTemplate(item._id)"><i class="far fa-trash-alt"></i></a></td>
                  </tr>
                </tbody>
              </table>
            </template>

            <template slot="noresults">
              {{ $t('There are no items') }}
            </template>
          </Paginaty>
          <RequisitionForm
            v-if="modal_select"
            :initRequisition="modal_select"
            :template="true"
            @hideModal="hideModal()" 
            @deleted="loadData(); hideModal()" 
            @saved="loadData(paginate.page); hideModal()">
            </RequisitionForm>
        </div>
      </div>
    </div>
</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import RequisitionForm from '@/components/RequisitionForm/RequisitionForm'
import Paginaty from '@/components/Paginaty/Paginaty'
import Unavailable from '../Unavailable/Unavailable'

export default {
  name: 'RequisitionTemplate',
  components: {
    ThSort,
    RequisitionForm,
    InputKeyword,
    Paginaty,
    Unavailable
  },
  data () {
    return {
      unavailable: false,
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'name'
    }
  },
  computed: {
    requisitions () {
      return this.$store.getters.getRequisitions
    },
    paginate () {
      return this.$store.getters.getRequisitionsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        template: true,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectRequisitions', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      }).catch(err => {
        this.unavailable = err.response && err.response.data && err.response.data.name === 'UpgradeRequired'
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {title: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    deleteTemplate
    */
    deleteTemplate (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteRequisition', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RequisitionTemplate/RequisitionTemplate.vue